import {brand, Branded, string, TypeOf} from 'io-ts';

interface SourceBrand {
    readonly Source: unique symbol;
}
export const Source = brand(string, (n): n is Branded<string, SourceBrand> => n.includes('/'), 'Source');
export type Source = TypeOf<typeof Source>;
